module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//2.jpg?e571dd3d6a470bf84334d0460ab3a3f3";